import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { LocationCardWrapper } from 'owa-location-card-v2';
import { isWebUrlLocation, openWebLocation } from 'owa-location-persona';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import { Link } from 'office-ui-fabric-react/lib/Link';

export interface LocationWrapperProps {
    item: MeetingRequestMessageType;
    className?: string;
}

const LocationWrapper: React.FunctionComponent<LocationWrapperProps> = observer(props => {
    const { item, className } = props;

    if (isWebUrlLocation(item.Location)) {
        return (
            <Link className={className} onClick={openWebLocation(item.Location.DisplayName)}>
                {item.Location.DisplayName}
            </Link>
        );
    } else {
        const locationElement = item.Location && <> {item.Location.DisplayName} </>;
        const locationId = getLocationId(item.Location);
        return (
            <LocationCardWrapper
                name={item.Location.DisplayName}
                postalAddress={item.Location.PostalAddress}
                key={locationId}
                locationId={locationId}
                locationAriaLabel={item.Location.DisplayName}>
                {locationElement}
            </LocationCardWrapper>
        );
    }
});

export default LocationWrapper;

/**
 * Workaround to get the location Id from the location Uri or display name until server returns Location Id in meeting message
 */
function getLocationId(location: EnhancedLocation) {
    return location.PostalAddress && location.PostalAddress.LocationUri
        ? location.PostalAddress.LocationUri
        : location.DisplayName;
}
